import { Box, Grid, Typography } from "@mui/material";
import { getTracesNoticesCount } from "api/services/automation/dashboard-tan";
import { useQuery } from "react-query";
import { ResType } from "types";
import { StyledTaskBox } from "views/dashboard/OrgDashboard/styles";
import { useState } from "react";
import { getCurrentFinancialYear } from "pages/atom-pro/Tan/constants";

import TracesIssuesNotice from "./TracesIssueNotice";

const TracesNotices = () => {
  const [financialYear, setFinancialYear] = useState(getCurrentFinancialYear(new Date()));

  const { data, isLoading }: ResType = useQuery(
    ["traces-notice-count", { financialYear }],
    getTracesNoticesCount
  );

  // if (isLoading) return <Loader />
  return (
    <StyledTaskBox>
      <header
        style={{
          backgroundColor: "#e6f2ff",
          padding: "5px",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          gap={1}
          width={"100%"}
        >
          <Typography variant="h6" alignItems="center">
            Traces Notices
          </Typography>
        </Box>
      </header>
      <main>
        <Box width="100%">
          <Grid container>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TracesIssuesNotice state={data?.data?.issueData} assessmentYear={financialYear} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </main>
    </StyledTaskBox>
  );
};
export default TracesNotices;
